import { FC, Fragment, JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { AddRounded as AddRoundedIcon } from '@mui/icons-material';

//components
import BottlePriceTable from './BottlePriceTable';
// constant, styles, reducer, graphql
import { flexCenterBetween } from 'styles/commonComponentStyle';
import { ADD_BOTTLE_PRICE_ROUTE, ADD_NEW_TEXT, BOTTLE_PRICE_TEXT } from 'constants/index';

const BottlePrice: FC = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <Box sx={flexCenterBetween}>
        <Typography variant="h5">{BOTTLE_PRICE_TEXT}</Typography>
        <Button variant="contained" color="primary" onClick={() => navigate(ADD_BOTTLE_PRICE_ROUTE)}>
          <AddRoundedIcon />
          {ADD_NEW_TEXT}
        </Button>
      </Box>
      <BottlePriceTable />
    </Fragment>
  );
};

export default BottlePrice;
